import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import useTranslation from "../hooks/useTranslation";

interface TruncateTextProps {
  text: string;
  maxLength: number;
}

const TruncateText = ({ text, maxLength }: TruncateTextProps) => {
  const { translate } = useTranslation("common");
  const [showMoreText, setShowMoreText] = useState(false);

  const handleShowMore = () => {
    setShowMoreText(!showMoreText);
  };

  const truncateText =
    text?.length > maxLength
      ? `${text.slice(0, showMoreText ? text?.length : maxLength)} ${showMoreText ? "\u00A0" : "...\u00A0"}`
      : text;

  const isShowReadMoreButton = text?.length > maxLength;
  const buttonText = showMoreText ? translate("readLess") : translate("readMore");

  return (
    <>
      <Box component="span">{truncateText}</Box>
      {isShowReadMoreButton && (
        <Button variant="text" onClick={handleShowMore} sx={{ whiteSpace: "nowrap", padding: 0, fontWeight: 500 }}>
          {buttonText}
        </Button>
      )}
    </>
  );
};
export default TruncateText;